export const CHECKOUT_STAGE = {
  LOADING: "LOADING",

  PAYMENT: "PAYMENT",

  VERIFYING: "VERIFYING",

  ERROR: "ERROR",

  ALREADY_SUBSCRIBED: "ALREADY_SUBSCRIBED",

  PROCESSING_EXISTING_INTENT: "PROCESSING_EXISTING_INTENT",
};
